module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABM0lEQVR4AWOgE0jDj0SY4sPZ3Wby6hHQwM2Y5Mnm3cNjvFdA8aCs7rXMEuwaWBhSrFgDG7nNdwoo7xdTuxCW9Grrzm+vXn158xJdgz5LaCGX7QZ+NaCRZz3DHs9a+PPV65u7Vy/I8Km1kLx//ihUuTxzdBKH00o+DaC646Yu99onfLv74M+3b0D06dWLyV4qlRIMk2Ntn796A9UAVAdHQEUI9P3749vHnj18ONVZfmNL1sdPn6EaVJgjUzgcITactPa83zUJasP3L/ePNjw8P3Pv9NCnt078+/0b3Q+GLCElXDab+FVBfvCOeDJv6bfXD+8c7T63NffTm1tAI3CGkg1rQDO3GSSULkamvly/9feHj+gaMBEvY6IPm1cfjxEoHhQMruWUkRDT0Ryu83h1GAYlAACQ5LBUyA9hmAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/AS.png
// module id = 1078
// module chunks = 0